export const CREATE_WPS_EXCEL_CONFIG = "CREATE_WPS_EXCEL_CONFIG";
export const FETCH_WPS_EXCEL_CONFIGS = "FETCH_WPS_EXCEL_CONFIGS";
export const FETCH_WPS_EXCEL_CONFIG = "FETCH_WPS_EXCEL_CONFIG";
export const EDIT_WPS_EXCEL_CONFIG = "EDIT_WPS_EXCEL_CONFIG";
export const EDIT_WPS_EXCEL_CONFIGS = "EDIT_WPS_EXCEL_CONFIGS";
export const SORT_WPS_EXCEL_CONFIGS = "SORT_WPS_EXCEL_CONFIGS";
export const DELETE_WPS_EXCEL_CONFIG = "DELETE_WPS_EXCEL_CONFIG";
